import classNames from 'classnames'
import Header from './Header'
import BottomLeftUnits from './BottomLeftUnits'
import FooterBig from './FooterBig'

const PageTemplate = ({
	children,
	isFullWidth = false,
	isFullHeight = false,
	isWithoutTopMargin = false,
}: {
	children: React.ReactNode
	isFullWidth?: boolean
	isFullHeight?: boolean
	isWithoutTopMargin?: boolean
}) => {
	return (
		<>
			{/* <Head>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
				/>
			</Head> */}
			<Header />
			<div
				className={classNames({
					container: true,
					'fixed-100-percent-height': isFullHeight,
					'page-column': !isFullWidth,
					'no-top-margin': isWithoutTopMargin,
				})}
			>
				{children}
			</div>
			<FooterBig />
			<BottomLeftUnits />
		</>
	)
}

export default PageTemplate
